import React from 'react';
import { connect } from 'react-redux';
import {
  Card, CardBody, CardTitle,
} from 'reactstrap';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import qs from 'qs';
import ImmutablePropTypes from 'react-immutable-proptypes';
import {
  searchReferences as searchReferencesAc,
  clearRedirect as clearRedirectAc,
  clearReferenceSearch as clearReferenceSearchAc,
} from '../../../../redux/references/search/referenceSearchActions';
import {
  deleteReference as deleteReferenceAc,
  getHaves as getHavesAc,
  clearReferenceData as clearReferenceDataAc,
  sortData as sortDataAc,

  getEqRegions as getEqRegionsAc,

  getVolRegions as getVolRegionsAc,

  getVolLocRegions as getVolLocRegionsAc,

  getTsuCauses as getTsuCausesAc,
  getTsuRegions as getTsuRegionsAc,
  getTsuRunupMeasurementTypes as getTsuRunupMeasurementTypesAc,
  getTsuValidity as getTsuValidityAc,

  getDepPublicationTypes as getDepPublicationTypesAc,
  getDepGeologicAges as getDepGeologicAgesAc,

  getRunupValidity as getRunupValidityAc,
  getRunupCauses as getRunupCausesAc,
  getRunupRunupMeasurementTypes as getRunupRunupMeasurementTypesAc,
  getRunupRegions as getRunupRegionsAc,
  toggleColumns as toggleColumnsAc,
} from '../../../../redux/references/data/referenceDataActions';
import { SearchParamDisplay } from '../../../data/SearchParamDisplay';
import { resolveSearchParameters } from '../search/referenceSearchParameterNameResolver';
import { Loading } from '../../../loadbar/Loading';
import { ReferenceDataGrid } from './ReferenceDataGrid';
import { isDataManager } from '../../../../role/roleUtils';
import { withUser } from '../../../auth/withUser';

class ReferenceContainerUnwrapped extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      queryParameters: {},
    };
  }

  componentDidMount() {
    document.title = 'NCEI Hazard Reference Results';
    const {
      clearReferenceData,
      getHaves,
      searchReferences,
      clearRedirect,
      searchRedirect,

      getEqRegions,

      getVolRegions,

      getVolLocRegions,

      getTsuCauses,
      getTsuRunupMeasurementTypes,
      getTsuValidity,
      getTsuRegions,

      getDepPublicationTypes,
      getDepGeologicAges,

      getRunupCauses,
      getRunupRunupMeasurementTypes,
      getRunupValidity,
      getRunupRegions,

      location: { search },
      history,
    } = this.props;
    clearReferenceData();
    getHaves({ history });

    getEqRegions({ history });

    getVolRegions({ history });

    getVolLocRegions({ history });

    getTsuCauses({ history });
    getTsuRunupMeasurementTypes({ history });
    getTsuValidity({ history });
    getTsuRegions({ history });

    getDepPublicationTypes({ history });
    getDepGeologicAges({ history });

    getRunupCauses({ history });
    getRunupRunupMeasurementTypes({ history });
    getRunupValidity({ history });
    getRunupRegions({ history });

    let queryParameters = {};
    if (search.length) {
      queryParameters = qs.parse(search.split('?')[1]);
    }

    if (!searchRedirect) {
      searchReferences({ queryParameters, history });
    } else {
      clearRedirect();
    }

    this.setState({ queryParameters });
  }

  componentWillUnmount() {
    const { clearReferenceSearch, clearReferenceData } = this.props;
    clearReferenceSearch();
    clearReferenceData();
  }

  render() {
    const {
      references,
      fetched,
      deleting,
      haves,
      sort,
      visibleColumns,
      toggleColumns,
      sortData,
      deleteReference,
      history,
      searchReferences,
      authorities,

      eqRegions,

      volRegions,

      volLocRegions,

      tsuValidities,
      tsuCauses,
      tsuRunupMeasurementTypes,
      tsuRegions,

      depPublicationTypes,
      depGeologicAges,

      runupCauses,
      runupRunupMeasurementTypes,
      runupValidities,
      runupRegions,

      peopleDescriptors,
      damageDescriptors,
      housesDescriptors,
    } = this.props;
    const { queryParameters } = this.state;

    if (!fetched) {
      return (<Loading />);
    }

    const sp = resolveSearchParameters({
      params: queryParameters,
      haves,

      peopleDescriptors,
      damageDescriptors,
      housesDescriptors,

      eqRegions,

      volRegions,

      volLocRegions,

      tsuValidities,
      tsuCauses,
      tsuRunupMeasurementTypes,
      tsuRegions,

      depPublicationTypes,
      depGeologicAges,

      runupCauses,
      runupRunupMeasurementTypes,
      runupValidities,
      runupRegions,
    });

    const dataManager = isDataManager(authorities);

    return (
      <div className="haz-results-container haz-page-container">

        {Boolean(sp.length) && <SearchParamDisplay messages={sp} />}

        <div className="haz-data-grid-container">
          <Card>
            <CardBody>
              <CardTitle tag="h2">{`References - ${references.size} Results Found`}</CardTitle>

              <ReferenceDataGrid
                references={references}
                dataManager={dataManager}
                sortData={sortData}
                sort={sort}
                visibleColumns={visibleColumns}
                toggleColumns={toggleColumns}
                searchParams={JSON.stringify(sp)}
                deleting={deleting}
                deleteReference={deleteReference}
                history={history}
                onDeleteCloseModal={() => searchReferences({ queryParameters, history })}
              />

            </CardBody>
          </Card>
        </div>
      </div>
    );
  }
}

ReferenceContainerUnwrapped.propTypes = {
  authorities: ImmutablePropTypes.list.isRequired,
  location: PropTypes.shape({
    search: PropTypes.string,
  }).isRequired,
  fetched: PropTypes.bool.isRequired,
  deleting: PropTypes.bool.isRequired,
  references: ImmutablePropTypes.list.isRequired,
  searchReferences: PropTypes.func.isRequired,
  clearReferenceSearch: PropTypes.func.isRequired,
  deleteReference: PropTypes.func.isRequired,
  history: PropTypes.shape({}).isRequired,
  clearRedirect: PropTypes.func.isRequired,
  searchRedirect: PropTypes.bool.isRequired,
  getHaves: PropTypes.func.isRequired,
  haves: ImmutablePropTypes.list.isRequired,
  clearReferenceData: PropTypes.func.isRequired,
  sortData: PropTypes.func.isRequired,
  sort: ImmutablePropTypes.list.isRequired,
  visibleColumns: ImmutablePropTypes.list.isRequired,
  toggleColumns: PropTypes.func.isRequired,

  getEqRegions: PropTypes.func.isRequired,
  eqRegions: ImmutablePropTypes.list.isRequired,

  getVolRegions: PropTypes.func.isRequired,
  volRegions: ImmutablePropTypes.list.isRequired,

  getVolLocRegions: PropTypes.func.isRequired,
  volLocRegions: ImmutablePropTypes.list.isRequired,

  getTsuRunupMeasurementTypes: PropTypes.func.isRequired,
  getTsuValidity: PropTypes.func.isRequired,
  getTsuCauses: PropTypes.func.isRequired,
  getTsuRegions: PropTypes.func.isRequired,
  tsuRunupMeasurementTypes: ImmutablePropTypes.list.isRequired,
  tsuValidities: ImmutablePropTypes.list.isRequired,
  tsuCauses: ImmutablePropTypes.list.isRequired,
  tsuRegions: ImmutablePropTypes.list.isRequired,

  getDepPublicationTypes: PropTypes.func.isRequired,
  getDepGeologicAges: PropTypes.func.isRequired,
  depPublicationTypes: ImmutablePropTypes.list.isRequired,
  depGeologicAges: ImmutablePropTypes.list.isRequired,

  getRunupValidity: PropTypes.func.isRequired,
  getRunupCauses: PropTypes.func.isRequired,
  getRunupRegions: PropTypes.func.isRequired,
  getRunupRunupMeasurementTypes: PropTypes.func.isRequired,
  runupValidities: ImmutablePropTypes.list.isRequired,
  runupCauses: ImmutablePropTypes.list.isRequired,
  runupRegions: ImmutablePropTypes.list.isRequired,
  runupRunupMeasurementTypes: ImmutablePropTypes.list.isRequired,

  peopleDescriptors: ImmutablePropTypes.list.isRequired,
  damageDescriptors: ImmutablePropTypes.list.isRequired,
  housesDescriptors: ImmutablePropTypes.list.isRequired,
};

const mapStateToProps = state => ({
  fetched: [
    state.getIn(['referenceSearchPage', 'fetched']),
    state.getIn(['referenceDataPage', 'fetchedHaves']),

    state.getIn(['referenceDataPage', 'eqFetchedRegions']),

    state.getIn(['referenceDataPage', 'volFetchedRegions']),

    state.getIn(['referenceDataPage', 'volLocFetchedRegions']),

    state.getIn(['referenceDataPage', 'tsuFetchedRegions']),
    state.getIn(['referenceDataPage', 'tsuFetchedRunupMeasurementTypes']),
    state.getIn(['referenceDataPage', 'tsuFetchedValidities']),
    state.getIn(['referenceDataPage', 'tsuFetchedCauses']),

    state.getIn(['referenceDataPage', 'depFetchedPublicationTypes']),
    state.getIn(['referenceDataPage', 'depFetchedGeologicAges']),

    state.getIn(['referenceDataPage', 'runupFetchedRegions']),
    state.getIn(['referenceDataPage', 'runupFetchedRunupMeasurementTypes']),
    state.getIn(['referenceDataPage', 'runupFetchedValidities']),
    state.getIn(['referenceDataPage', 'runupFetchedCauses']),
  ].every(v => v),
  deleting: state.getIn(['referenceDataPage', 'deleting']),
  references: state.getIn(['referenceSearchPage', 'references']),
  searchRedirect: state.getIn(['referenceSearchPage', 'searchRedirect']),
  haves: state.getIn(['referenceDataPage', 'haves']),
  sort: state.getIn(['referenceSearchPage', 'sort']),
  visibleColumns: state.getIn(['referenceDataPage', 'visibleColumns']),

  eqRegions: state.getIn(['referenceSearchPage', 'eqRegions']),

  volRegions: state.getIn(['referenceDataPage', 'volRegions']),

  volLocRegions: state.getIn(['referenceDataPage', 'volLocRegions']),

  tsuValidities: state.getIn(['referenceDataPage', 'tsuValidities']),
  tsuCauses: state.getIn(['referenceDataPage', 'tsuCauses']),
  tsuRegions: state.getIn(['referenceDataPage', 'tsuRegions']),
  tsuRunupMeasurementTypes: state.getIn(['referenceDataPage', 'tsuRunupMeasurementTypes']),

  depPublicationTypes: state.getIn(['referenceDataPage', 'depPublicationTypes']),
  depGeologicAges: state.getIn(['referenceDataPage', 'depGeologicAges']),

  runupValidities: state.getIn(['referenceDataPage', 'runupValidities']),
  runupCauses: state.getIn(['referenceDataPage', 'runupCauses']),
  runupRegions: state.getIn(['referenceDataPage', 'runupRegions']),
  runupRunupMeasurementTypes: state.getIn(['referenceDataPage', 'runupRunupMeasurementTypes']),

  damageDescriptors: state.getIn(['effectDescriptors', 'damage']),
  peopleDescriptors: state.getIn(['effectDescriptors', 'people']),
  housesDescriptors: state.getIn(['effectDescriptors', 'houses']),
});

const mapDispatchToProps = dispatch => bindActionCreators({
  searchReferences: searchReferencesAc,
  clearReferenceSearch: clearReferenceSearchAc,
  deleteReference: deleteReferenceAc,
  clearRedirect: clearRedirectAc,
  getHaves: getHavesAc,
  clearReferenceData: clearReferenceDataAc,
  sortData: sortDataAc,
  toggleColumns: toggleColumnsAc,
  getEqRegions: getEqRegionsAc,

  getVolRegions: getVolRegionsAc,

  getVolLocRegions: getVolLocRegionsAc,

  getTsuCauses: getTsuCausesAc,
  getTsuRegions: getTsuRegionsAc,
  getTsuRunupMeasurementTypes: getTsuRunupMeasurementTypesAc,
  getTsuValidity: getTsuValidityAc,

  getDepPublicationTypes: getDepPublicationTypesAc,
  getDepGeologicAges: getDepGeologicAgesAc,

  getRunupValidity: getRunupValidityAc,
  getRunupCauses: getRunupCausesAc,
  getRunupRunupMeasurementTypes: getRunupRunupMeasurementTypesAc,
  getRunupRegions: getRunupRegionsAc,

}, dispatch);


export const ReferenceContainer = withUser(connect(mapStateToProps, mapDispatchToProps)(ReferenceContainerUnwrapped));
